import { ChartDirectiveBase } from './ChartDirectiveBase';
import { Margins, ChartOptions } from '../../../models/index';
import { SvgManager } from '../../../charting/SvgManager';
import { HorizontalBarChart } from '../../../charting/index';

export interface IhorizontalBarChartDirective extends ng.IDirective {
}

export interface IhorizontalBarChartDirectiveScope extends ng.IScope {
    chartData: any;
    options: any;
    id: any;
    series: any;
    labels: any;
}

export class HorizontalBarChartDirective extends ChartDirectiveBase implements IhorizontalBarChartDirective {
    static directiveId = 'wtHorizontalBarChart';

    constructor() {
        super();
        this.scope = {
            chartData: '=',
            options: '=',
            id: '@',
            series: '=',
            labels: '='
        };
    }

    link(scope: IhorizontalBarChartDirectiveScope, element, attrs, controller) {
        const containerName = attrs.id;
        element.attr('id', containerName);
        const margins = new Margins(0, 0, 10, 0);
        const svgManager = new SvgManager(containerName, margins);
        const options = new ChartOptions(80, 20, 0, 50);
        const plot = new HorizontalBarChart(options, svgManager);

        const chartOptions = scope.options;
        if (chartOptions) {
            scope.$watch(() => chartOptions.title, () => {
                plot.titleText(chartOptions.title);
            });
            scope.$watch(() => chartOptions.isTitleVisible, () => {
                plot.isTitleVisible(chartOptions.isTitleVisible);
            });
            scope.$watch(() => chartOptions.seriesClick, () => {
                plot.seriesClick(chartOptions.seriesClick);
            });
            scope.$watch(() => chartOptions.numberFormat, () => {
                plot.numberFormat(chartOptions.numberFormat);
            });
        }
        scope.$watchCollection(() => scope.chartData, () => {
            plot.update(scope.chartData);
        });
        scope.$watchCollection(() => scope.labels, () => {
            plot.labels(scope.labels);
        });
    }
}